/**
 * The group a path is ABOUT, or null.
 *
 * The sidebars answered this per row with
 * ``pathname.includes(`/grupper/${slug}`)``, which substring-matches: on
 * `/grupper/caisa-os-data` the row for `caisa` matched too and both lit up as
 * the current group (OSO-553). The first segment after `/grupper/` is the whole
 * answer, so it is taken once and compared for equality.
 *
 * RESERVED SEGMENTS ARE NOT GROUPS. `/grupper/opret` and `/grupper/mine` are
 * the two sibling routes of `[slug]`, and `app/grupper/layout.tsx` hands
 * whatever comes back here to `useV1Group`, which is `enabled` for any
 * non-empty string — so "opret" was fetched, and 404'd by construction, on
 * every visit to the create-group page. Nothing broke visibly, which is why it
 * survived: the sidebar simply had no group. It is excluded here because this
 * is now the one place that decides what a group slug in a path is.
 */
const RESERVED_SEGMENTS = new Set(["opret", "mine"]);

export function activeGroupSlug(pathname: string): string | null {
  const segment = pathname.match(/^\/grupper\/([^/]+)/)?.[1];
  return segment && !RESERVED_SEGMENTS.has(segment) ? segment : null;
}
